import { createFileRoute } from "@tanstack/react-router";
import MapController from "@/components/Map/components/MapController";

export const Route = createFileRoute("/_auth/kart/asset")({
  component: () => <MapController mode="asset" />,
});
